// extracted by mini-css-extract-plugin
export default {"wrapper":"info-box_wrapper__SFhe3"};